const commsPerDayHour = [
    {
        datetime: "2022-05-18T00:00:00.000Z",
        perHour: [
            {
                datetime: "2022-05-18T00:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-18T01:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-18T02:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-18T03:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-18T04:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-18T05:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-18T06:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-18T07:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 1,
            },
            {
                datetime: "2022-05-18T08:00:00.000Z",
                reactions: 0,
                messages: 19,
                huddles: 0,
                meetings: 2,
            },
            {
                datetime: "2022-05-18T09:00:00.000Z",
                reactions: 0,
                messages: 13,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-18T10:00:00.000Z",
                reactions: 0,
                messages: 1,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-18T11:00:00.000Z",
                reactions: 0,
                messages: 5,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-18T12:00:00.000Z",
                reactions: 0,
                messages: 1,
                huddles: 0,
                meetings: 1,
            },
            {
                datetime: "2022-05-18T13:00:00.000Z",
                reactions: 0,
                messages: 2,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-18T14:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-18T15:00:00.000Z",
                reactions: 0,
                messages: 3,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-18T16:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-18T17:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-18T18:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-18T19:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-18T20:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-18T21:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-18T22:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-18T23:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
        ],
    },
    {
        datetime: "2022-05-19T00:00:00.000Z",
        perHour: [
            {
                datetime: "2022-05-19T00:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-19T01:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-19T02:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-19T03:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-19T04:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-19T05:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-19T06:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-19T07:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-19T08:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-19T09:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-19T10:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-19T11:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-19T12:00:00.000Z",
                reactions: 0,
                messages: 3,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-19T13:00:00.000Z",
                reactions: 0,
                messages: 21,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-19T14:00:00.000Z",
                reactions: 0,
                messages: 7,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-19T15:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-19T16:00:00.000Z",
                reactions: 0,
                messages: 14,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-19T17:00:00.000Z",
                reactions: 0,
                messages: 20,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-19T18:00:00.000Z",
                reactions: 0,
                messages: 19,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-19T19:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-19T20:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-19T21:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-19T22:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-19T23:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
        ],
    },
    {
        datetime: "2022-05-20T00:00:00.000Z",
        perHour: [
            {
                datetime: "2022-05-20T00:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-20T01:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-20T02:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-20T03:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-20T04:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-20T05:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-20T06:00:00.000Z",
                reactions: 0,
                messages: 1,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-20T07:00:00.000Z",
                reactions: 0,
                messages: 1,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-20T08:00:00.000Z",
                reactions: 0,
                messages: 13,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-20T09:00:00.000Z",
                reactions: 0,
                messages: 8,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-20T10:00:00.000Z",
                reactions: 0,
                messages: 2,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-20T11:00:00.000Z",
                reactions: 0,
                messages: 14,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-20T12:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-20T13:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-20T14:00:00.000Z",
                reactions: 0,
                messages: 1,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-20T15:00:00.000Z",
                reactions: 0,
                messages: 15,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-20T16:00:00.000Z",
                reactions: 0,
                messages: 2,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-20T17:00:00.000Z",
                reactions: 0,
                messages: 10,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-20T18:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-20T19:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-20T20:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-20T21:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-20T22:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-20T23:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
        ],
    },
    {
        datetime: "2022-05-21T00:00:00.000Z",
        perHour: [
            {
                datetime: "2022-05-21T00:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-21T01:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-21T02:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-21T03:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-21T04:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-21T05:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-21T06:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-21T07:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-21T08:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-21T09:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-21T10:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-21T11:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-21T12:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-21T13:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-21T14:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-21T15:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-21T16:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-21T17:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-21T18:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-21T19:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-21T20:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-21T21:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-21T22:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-21T23:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
        ],
    },
    {
        datetime: "2022-05-22T00:00:00.000Z",
        perHour: [
            {
                datetime: "2022-05-22T00:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-22T01:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-22T02:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-22T03:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-22T04:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-22T05:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-22T06:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-22T07:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-22T08:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-22T09:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-22T10:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-22T11:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-22T12:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-22T13:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-22T14:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-22T15:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-22T16:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-22T17:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-22T18:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-22T19:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-22T20:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-22T21:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 1,
            },
            {
                datetime: "2022-05-22T22:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-22T23:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 1,
            },
        ],
    },
    {
        datetime: "2022-05-23T00:00:00.000Z",
        perHour: [
            {
                datetime: "2022-05-23T00:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-23T01:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-23T02:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-23T03:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-23T04:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-23T05:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-23T06:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-23T07:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-23T08:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-23T09:00:00.000Z",
                reactions: 0,
                messages: 22,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-23T10:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-23T11:00:00.000Z",
                reactions: 2,
                messages: 3,
                huddles: 1,
                meetings: 0,
            },
            {
                datetime: "2022-05-23T12:00:00.000Z",
                reactions: 0,
                messages: 1,
                huddles: 1,
                meetings: 0,
            },
            {
                datetime: "2022-05-23T13:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 1,
                meetings: 0,
            },
            {
                datetime: "2022-05-23T14:00:00.000Z",
                reactions: 0,
                messages: 4,
                huddles: 1,
                meetings: 0,
            },
            {
                datetime: "2022-05-23T15:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 1,
                meetings: 0,
            },
            {
                datetime: "2022-05-23T16:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-23T17:00:00.000Z",
                reactions: 1,
                messages: 3,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-23T18:00:00.000Z",
                reactions: 0,
                messages: 1,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-23T19:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-23T20:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-23T21:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-23T22:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-23T23:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
        ],
    },
    {
        datetime: "2022-05-24T00:00:00.000Z",
        perHour: [
            {
                datetime: "2022-05-24T00:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-24T01:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-24T02:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-24T03:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-24T04:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-24T05:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-24T06:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-24T07:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-24T08:00:00.000Z",
                reactions: 1,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-24T09:00:00.000Z",
                reactions: 0,
                messages: 2,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-24T10:00:00.000Z",
                reactions: 0,
                messages: 4,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-24T11:00:00.000Z",
                reactions: 0,
                messages: 2,
                huddles: 1,
                meetings: 0,
            },
            {
                datetime: "2022-05-24T12:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 1,
                meetings: 0,
            },
            {
                datetime: "2022-05-24T13:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 1,
                meetings: 0,
            },
            {
                datetime: "2022-05-24T14:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 2,
                meetings: 0,
            },
            {
                datetime: "2022-05-24T15:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 1,
                meetings: 0,
            },
            {
                datetime: "2022-05-24T16:00:00.000Z",
                reactions: 1,
                messages: 1,
                huddles: 1,
                meetings: 0,
            },
            {
                datetime: "2022-05-24T17:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-24T18:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-24T19:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-24T20:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-24T21:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-24T22:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-24T23:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
        ],
    },
    {
        datetime: "2022-05-25T00:00:00.000Z",
        perHour: [
            {
                datetime: "2022-05-25T00:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-25T01:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-25T02:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-25T03:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-25T04:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-25T05:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-25T06:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-25T07:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-25T08:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-25T09:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-25T10:00:00.000Z",
                reactions: 0,
                messages: 9,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-25T11:00:00.000Z",
                reactions: 1,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-25T12:00:00.000Z",
                reactions: 0,
                messages: 13,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-25T13:00:00.000Z",
                reactions: 0,
                messages: 8,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-25T14:00:00.000Z",
                reactions: 0,
                messages: 9,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-25T15:00:00.000Z",
                reactions: 0,
                messages: 3,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-25T16:00:00.000Z",
                reactions: 0,
                messages: 29,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-25T17:00:00.000Z",
                reactions: 0,
                messages: 8,
                huddles: 1,
                meetings: 0,
            },
            {
                datetime: "2022-05-25T18:00:00.000Z",
                reactions: 0,
                messages: 1,
                huddles: 1,
                meetings: 0,
            },
            {
                datetime: "2022-05-25T19:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-25T20:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-25T21:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-25T22:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
            {
                datetime: "2022-05-25T23:00:00.000Z",
                reactions: 0,
                messages: 0,
                huddles: 0,
                meetings: 0,
            },
        ],
    },
];

const timeCollaboratedPerDay = [
    {
        datetime: "2022-10-06T00:00:00.000Z",
        chat: 2786,
        meetings: 1200,
        baseline: {
            chat: 2388.36,
            meetings: 72.86,
        },
    },
    {
        datetime: "2022-10-07T00:00:00.000Z",
        chat: 4402,
        meetings: 1299,
        baseline: {
            chat: 2461.43,
            meetings: 77.14,
        },
    },
    {
        datetime: "2022-10-08T00:00:00.000Z",
        chat: 0,
        meetings: 0,
        baseline: {
            chat: 72.86,
            meetings: 0,
        },
    },
    {
        datetime: "2022-10-09T00:00:00.000Z",
        chat: 0,
        meetings: 0,
        baseline: {
            chat: 8.57,
            meetings: 0,
        },
    },
    {
        datetime: "2022-10-10T00:00:00.000Z",
        chat: 2300,
        meetings: 1300,
        baseline: {
            chat: 2181.36,
            meetings: 60,
        },
    },
    {
        datetime: "2022-10-11T00:00:00.000Z",
        chat: 2798,
        meetings: 3000,
        baseline: {
            chat: 2287.71,
            meetings: 72.86,
        },
    },
    {
        datetime: "2022-10-12T00:00:00.000Z",
        chat: 2440,
        meetings: 1990,
        baseline: {
            chat: 2215.43,
            meetings: 90,
        },
    },
];

const messageCountPerDay = [
    {
        datetime: "2021-11-29T10:40:45.000Z",
        public: 20,
        private: 2,
        im: 2,
        all: 22,
        baseline: {
            public: 15,
            private: 2,
            im: 2,
            all: 16,
        },
    },
    {
        datetime: "2021-11-30T15:26:51.000Z",
        public: 12,
        private: 2,
        im: 2,
        all: 16,
        baseline: {
            public: 12,
            private: 2,
            im: 2,
            all: 16,
        },
    },
    {
        datetime: "2021-12-01T15:26:51.000Z",
        public: 0,
        private: 5,
        im: 1,
        all: 6,
        baseline: {
            public: 12,
            private: 2,
            im: 2,
            all: 16,
        },
    },
    {
        datetime: "2021-12-02T15:26:51.000Z",
        public: 8,
        private: 3,
        im: 10,
        all: 21,
        baseline: {
            public: 12,
            private: 2,
            im: 2,
            all: 16,
        },
    },
    {
        datetime: "2021-12-03T15:26:51.000Z",
        public: 10,
        private: 1,
        im: 2,
        all: 13,
        baseline: {
            public: 12,
            private: 2,
            im: 2,
            all: 16,
        },
    },
    {
        datetime: "2021-12-04T15:26:51.000Z",
        public: 10,
        private: 0,
        im: 20,
        all: 30,
        baseline: {
            public: 12,
            private: 2,
            im: 2,
            all: 16,
        },
    },
    {
        datetime: "2021-12-05T15:26:51.000Z",
        public: 14,
        private: 8,
        im: 3,
        all: 22,
        baseline: {
            public: 7,
            private: 2,
            im: 2,
            all: 11,
        },
    },
];

const meetingsBreakdownPerDay = [
    {
        responseStatus: {
            accepted: 0,
            declined: 0,
            tentative: 0,
            needsAction: 1,
        },
        datetime: "2022-10-06T00:00:00.000Z",
        recurring: {
            meetings: ["Daily Standup"],
            minutes: 60,
        },
        oneTime: {
            meetings: [],
            minutes: 0,
        },
        baseline: {
            oneTime: {
                minutes: 12.86,
                meetings: 0.14,
            },
            recurring: {
                minutes: 60,
                meetings: 1,
            },
        },
    },
    {
        responseStatus: {
            accepted: 0,
            declined: 0,
            tentative: 0,
            needsAction: 3,
        },
        datetime: "2022-10-07T00:00:00.000Z",
        recurring: {
            meetings: ["Daily Standup"],
            minutes: 60,
        },
        oneTime: {
            meetings: ["Demo for the video"],
            minutes: 60,
        },
        baseline: {
            oneTime: {
                minutes: 18.46,
                meetings: 0.23,
            },
            recurring: {
                minutes: 60,
                meetings: 1,
            },
        },
    },
    {
        responseStatus: {
            accepted: 0,
            declined: 0,
            tentative: 0,
            needsAction: 0,
        },
        datetime: "2022-10-08T00:00:00.000Z",
        recurring: {
            meetings: [],
            minutes: 0,
        },
        oneTime: {
            meetings: [],
            minutes: 0,
        },
        baseline: {
            oneTime: {
                minutes: 0,
                meetings: 0,
            },
            recurring: {
                minutes: 0,
                meetings: 0,
            },
        },
    },
    {
        responseStatus: {
            accepted: 0,
            declined: 0,
            tentative: 0,
            needsAction: 0,
        },
        datetime: "2022-10-09T00:00:00.000Z",
        recurring: {
            meetings: [],
            minutes: 0,
        },
        oneTime: {
            meetings: [],
            minutes: 0,
        },
        baseline: {
            oneTime: {
                minutes: 0,
                meetings: 0,
            },
            recurring: {
                minutes: 0,
                meetings: 0,
            },
        },
    },
    {
        responseStatus: {
            accepted: 0,
            declined: 0,
            tentative: 0,
            needsAction: 1,
        },
        datetime: "2022-10-10T00:00:00.000Z",
        recurring: {
            meetings: ["Daily Standup"],
            minutes: 60,
        },
        oneTime: {
            meetings: [],
            minutes: 0,
        },
        baseline: {
            oneTime: {
                minutes: 0,
                meetings: 0,
            },
            recurring: {
                minutes: 60,
                meetings: 1,
            },
        },
    },
    {
        responseStatus: {
            accepted: 0,
            declined: 0,
            tentative: 0,
            needsAction: 1,
        },
        datetime: "2022-10-11T00:00:00.000Z",
        recurring: {
            meetings: ["Daily Standup"],
            minutes: 60,
        },
        oneTime: {
            meetings: [],
            minutes: 0,
        },
        baseline: {
            oneTime: {
                minutes: 6.92,
                meetings: 0.15,
            },
            recurring: {
                minutes: 66.92,
                meetings: 1.23,
            },
        },
    },
    {
        responseStatus: {
            accepted: 0,
            declined: 0,
            tentative: 0,
            needsAction: 2,
        },
        datetime: "2022-10-12T00:00:00.000Z",
        recurring: {
            meetings: ["Daily Standup"],
            minutes: 60,
        },
        oneTime: {
            meetings: ["Prepare architecture for AWS"],
            minutes: 60,
        },
        baseline: {
            oneTime: {
                minutes: 18.46,
                meetings: 0.31,
            },
            recurring: {
                minutes: 76.15,
                meetings: 1.31,
            },
        },
    },
];

const channels = [
    {
        id: 1122,
        name: "Internet Things",
        interactionCount: 108,
        baseline: 100,
    },
    {
        id: 1122,
        name: "Tech Hideout",
        interactionCount: 90,
        baseline: 10,
    },
    {
        id: 1122,
        name: "Internet Things",
        interactionCount: 108,
        baseline: 100,
    },
];

const meetingFrequencyV1 = [
    {
        name: "Daily Standup",
        duration: 408,
        baseline: 100,
    },
    {
        name: "Sales Meeting",
        duration: 90,
        baseline: 10,
    },
    {
        name: "Backlog refinement",
        duration: 108,
        baseline: 100,
    },
];

const meetingCollaboratorsV1 = [
    {
        email: "Ibi Jetson",
        meetings: 2,
        duration: 60,
        user_type: "external",
    },
    {
        email: "Dime Detmers",
        meetings: 1,
        duration: 45,
        user_type: "external",
    },
    {
        email: "Dexter Holland",
        meetings: 1,
        duration: 25,
        user_type: "external",
    },
    {
        email: "Super Tester",
        meetings: 1,
        duration: 45,
        user_type: "internal",
    },
    {
        email: "Elli Desmonds",
        meetings: 1,
        duration: 45,
        user_type: "internal",
    },
];

const meetingsCancelledV1 = [
    { name: "Product test", count: 2 },
    { name: "Monthly sales", count: 1 },
];

const meetingsRescheduledV1 = [
    { name: "Product test round two", count: 2 },
    { name: "Meet the residents", count: 3 },
];

const stats = {
    messagesSent: 21,
    reactionsAdded: 9,
    huddleTime: 1265,
    meetingsTime: 3504,
    sizeOfNetwork: 5,
    baseline: {
        messagesSent: 18,
        reactionsAdded: 5,
        huddleTime: 1200,
        meetingsTime: 3504,
        sizeOfNetwork: 4,
    },
};

const statsBaseline = {
    messagesSent: 18,
    reactionsAdded: 5,
    huddleTime: 1200,
    meetingsTime: 3504,
    sizeOfNetwork: 4,
};
const meta = {
    inactive: false,
    lastActiveAt: 1653523200,
    firstScrappedDate: 1650412800,
};

const getCollaboration = () => {
    return {
        commsPerDayHour,
        channels,
        meetingFrequency: meetingFrequencyV1,
        meetingsBreakdownPerDay,
        timeCollaboratedPerDay,
        messageCountPerDay,
        meetingCollaborators: meetingCollaboratorsV1,
        meetingsCancelled: meetingsCancelledV1,
        meetingsRescheduled: meetingsRescheduledV1,
        stats,
        statsBaseline,
        meta,
    };
};

export default getCollaboration;
